import { icons } from 'lucide-react';

type TIcon = {
  name: string;
  size: number;
};

const Icon = ({ name, size }: TIcon) => {
  // @ts-expect-error dynamic key
  const LucideIcon = icons[name];

  return <LucideIcon size={size} />;
};

export default Icon;
